"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TableMixin = void 0;
var _styledComponents = require("styled-components");
var _styledToken = _interopRequireDefault(require("styled-token"));
var _TableBody = require("../../components/TableBody/TableBody.styles");
var _TableCell = require("../../components/TableCell/TableCell.styles");
var _TableHeader = require("../../components/TableHeader/TableHeader.styles");
var _TableHeaderCell = require("../../components/TableHeaderCell/TableHeaderCell.styles");
var _TableRow = require("../../components/TableRow/TableRow.styles");
var _tableResetMixin = require("../tableResetMixin");
var _typographyMixin = require("../typographyMixin");
var appearanceCSS = function appearanceCSS(props) {
  var appearance = props.appearance;
  return (0, _styledToken.default)({
    borderWidth: 'Table.borderWidth',
    borderColor: 'Table.borderColor',
    backgroundColor: 'Table.cellBackgroundColorLight',
    zebraBackgroundColor: 'Table.cellBackgroundColorDark'
  }, function (tokens) {
    var styles = [(0, _styledComponents.css)(["", " ", "{background-color:", ";}"], _TableBody.StyledTableBody, _TableCell.StyledTableCell, tokens.backgroundColor)];
    switch (appearance) {
      case 'barebones':
        styles.push((0, _styledComponents.css)(["", " ", "{border-bottom:", "px solid ", ";}"], _TableHeader.StyledTableHeader, _TableHeaderCell.StyledTableHeaderCell, tokens.borderWidth, tokens.borderColor));
        break;
      case 'horizontal':
        styles.push((0, _styledComponents.css)(["", "{border-bottom:", "px solid ", ";}"], _TableCell.StyledTableCell, tokens.borderWidth, tokens.borderColor));
        break;
      case 'zebra':
        styles.push((0, _styledComponents.css)(["", "{border-bottom:", "px solid ", ";}", " ", ":nth-child(2n) ", "{background-color:", ";}"], _TableCell.StyledTableCell, tokens.borderWidth, tokens.borderColor, _TableBody.StyledTableBody, _TableRow.StyledTableRow, _TableCell.StyledTableCell, tokens.zebraBackgroundColor));
        break;
      default:
        // default to "grid" styles
        styles.push((0, _styledComponents.css)(["&,", ",", "{border:", "px solid ", ";}"], _TableHeaderCell.StyledTableHeaderCell, _TableCell.StyledTableCell, tokens.borderWidth, tokens.borderColor));
        break;
    }
    return styles;
  })(props);
};
var sizeCSS = function sizeCSS(props) {
  var size = props.size;
  return (0, _styledToken.default)({
    verticalPadding: "Table.verticalPadding." + size,
    horizontalPadding: "Table.horizontalPadding." + size,
    fontType: "Table.fontType." + size,
    headerFontType: "Table.headerFontType." + size,
    fontWeights: 'fontWeights'
  }, function (tokens) {
    return (0, _styledComponents.css)(["", "{padding:", "px ", "px;", "}", " ", "{", ";}"], _TableCell.StyledTableCell, tokens.verticalPadding, tokens.horizontalPadding, (0, _typographyMixin.typographyMixin)(Object.assign({
      fontType: tokens.fontType
    }, props)), _TableHeader.StyledTableHeader, _TableHeaderCell.StyledTableHeaderCell, tokens.headerFontType && "font-weight: " + tokens.fontWeights[tokens.headerFontType]);
  })(props);
};
var alignmentsCSS = function alignmentsCSS(_ref) {
  var alignments = _ref.alignments;
  /* Set alignment styles here instead of in Table.Cell to
    ensure they get applied to dynamically-added rows:
    https://gitlab.zgtools.net/constellation/constellation/-/merge_requests/82 */
  var styles = [];
  for (var i = 0; i < alignments.length; i += 1) {
    styles.push((0, _styledComponents.css)(["", ":nth-child(", "){text-align:", ";}"], _TableCell.StyledTableCell, i + 1, alignments[i]));
  }
  return styles;
};

/** @class TableMixin */
/** @method */
var TableMixin = function TableMixin(props) {
  return [(0, _tableResetMixin.tableResetMixin)(props), appearanceCSS(props), sizeCSS(props), alignmentsCSS(props)];
};
exports.TableMixin = TableMixin;